// pages/Dashboard.jsx
import UserProfile from "../../components/home/userComponents/UserProfile";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <UserProfile />
    </HomeLayout>
  );
}
